const EventBus = window.EventBus;;
export const Searchables = {
  props: [
    'items',
    'component',
    'initialSelection',
  ],
  data(){
    return {
      selected: [],
      loaded: false,
    }
  },
  created(){

  },
  mounted(){
    EventBus.$on('CLEAR_ALL_SEARCHABLES_SELECTION', () => {
      this.clearSelection();
    })
  },
  methods: {
    entryPoint(items){
      this.selected = items.filter(i => {
        if(this.initialSelection.includes(i.replace(/ /g, '-').replace(/---/g, '-').toLowerCase()))
          return i;
      })
      this.$emit('updatechecked', {
        component: 'feature',
        selected: this.selected,
      })
    },
    clearSelection() {
      this.selected = [];
      this.$emit('updatechecked', {
        component: 'feature',
        selected: this.selected,
      })
    },
    paint(value){
      return this.items.indexOf(value) != -1;
    },
    isSelected(value){
      return this.selected.indexOf(value) != -1;
    },
    toggle(item) {
      if(this.selected.includes(item))
        this.selected.splice(this.selected.indexOf(item), 1);
      else
        this.selected.push(item);

      this.$emit('updatechecked', {
        component: 'feature',
        selected: this.selected,
      })
    }
  },
  watch: {
    items(items){
      if(!this.loaded)
      {
        this.entryPoint(items);
        this.loaded = true;
      }
    }
  }
}